export default {
	bind() {
    const vm = this;

		$('.modal-trigger').unbind().on('click', function (e) {
      e.preventDefault();

      const ref = $(this).data('ref');
      const target = $(this).data('target');
      const target_id = $(this).data('id');
      vm.show(target, ref);
    });
  },
  show(selector, ref) {
    const vm = this;

    $('html').addClass('is-clipped');
    $(selector).attr('data-ref', ref).addClass('is-active');

//  Hide Modal
    $(selector).find('.delete').unbind().on('click', function (e) {
      e.preventDefault();

      vm.hide(selector);
    });
  },
  hide(selector) {
    $('html').removeClass('is-clipped');
    $(selector).removeClass('is-active');
  }
};
